import api from './index';

// Get all blogs with pagination
export const getBlogsPage = (page = 1, per_page = 4) => {
  return api.get(`/blogs?page=${page}&per_page=${per_page}`);
};

// Get blog by slug
export const getBlogBySlug = (slug) => {
  return api.get(`/get-blog-by-slug?slug=${slug}`);
};

// Get blog details by ID
export const getBlogDetails = (id) => {
  return api.get(`/blogs/${id}`);
};

// Create new blog
export const createBlog = (blogData) => {
  const token = localStorage.getItem('token');
  return api.post('/blogs', blogData, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  });
};

// Update blog
export const updateBlog = (id, blogData) => {
  const token = localStorage.getItem('token');
  return api.put(`/blogs/${id}`, blogData, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  });
};

// Delete blog
export const deleteBlog = (id) => {
  const token = localStorage.getItem('token');
  return api.delete(`/blogs/${id}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

// Upload image
export const imageUpload = (formData) => {
  const token = localStorage.getItem('token');
  return api.post('/blogs/upload-image', formData, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Get all blogs (without pagination)
export const getAllBlogs = () => {
  return api.get('/blogs');
};
